import { Field } from "@sitecore-jss/sitecore-jss-react";
import React, { useState } from "react";

import { fetchDictionary } from "../../api/genericData";
import { TextHeader } from "../../components/headers/TextHeader";
import { TabPanel } from "../../components/tabs/TabPanel";
import { Tabs } from "../../components/tabs/Tabs";
import { useDidMount } from "../../hooks/useDidMount";
import styles from "./PolicyOverview.module.scss";
import { SearchDcpPolicy } from "./searchDcpPolicy/SearchDcpPolicy";
import { SearchDlpPolicy } from "./searchDlpPolicy/SearchDlpPolicy";
import { SearchDupDlpPolicy } from "./searchDupDlpPolicy/SearchDupDlpPolicy";

interface Props {
  fields: Record<string, Field<string & { href: string }>>;
}

export const PolicyOverview = ({ fields }: Props) => {
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [dictionary, setDictionary] = useState<Record<string, string>>({});

  const TABS = [
    {
      index: 0,
      label: "Overlijdensrisicoverzekering",
      children: <SearchDlpPolicy fields={fields} />,
    },
    {
      index: 1,
      label: "Uitvaartverzekering",
      children: <SearchDupDlpPolicy fields={fields} dictionary={dictionary} />,
    },
    {
      index: 2,
      label: "Spaarverzekering",
      children: <SearchDcpPolicy fields={fields} />,
    },
  ];

  useDidMount(async () => {
    try {
      const { phrases } = await fetchDictionary();
      setDictionary(phrases);
    } catch {
      // ignore errors
    }
  });

  const handleUpdateActiveTabIndex = (index: number) => {
    setActiveTabIndex(index);
  };

  return (
    <div>
      <TextHeader title={fields.HeaderTitle.value} subtitle={fields.HeaderText.value} />

      <Tabs tabs={TABS} activeTabIndex={activeTabIndex} setActiveTabIndex={handleUpdateActiveTabIndex} />

      <div className={styles.policyOverview__wrapper}>
        {TABS.map((tab) => (
          <TabPanel key={tab.label} index={tab.index} currentIndex={activeTabIndex}>
            {tab.children}
          </TabPanel>
        ))}
      </div>
    </div>
  );
};
